// extracted by mini-css-extract-plugin
export default {"like_wrap":"Likes_like_wrap__oXjvL","container":"Likes_container__SE7s0","heart":"Likes_heart__kC9Wu","liked":"Likes_liked__WYwZx"};